<template>
    <section class="select-service-container">
        <section-heading step='1' heading='Service Selection'></section-heading>
        <div class="div-container">
            <div class="select-row">
                <select class="select-box form-control" @change="selectService($event)">
                <option>Please Select...</option>
                <option
                    v-for="adviserService in adviserServices"
                    v-bind:key="adviserService.serviceId"
                    v-bind:value="adviserService.serviceId">
                {{ adviserService.serviceName }}
                </option>  
            </select> 
            </div>
        </div> 
    </section>
</template>

<script>
import SectionHeading from './SectionHeading.vue';
export default {
    components: {
        'section-heading': SectionHeading,
    },
    props: ['adviserServices'],
    methods: {
        selectService(event) {
            this.$emit('selectService', event.target.value);
        },
    },
};
</script>

<style lang="scss" scoped>
  .select-service-container {
      margin-bottom: var(--global-gutter-size);
      display: flex;
      flex-direction: column;
      border-radius: var(--global-card-radius);
      margin-bottom: 48px;
      .div-container {
          display: flex;
          flex-direction: column;
          .select-row {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-bottom: 8px;
              .select-label {
                  flex-basis: 120px;
                  margin: 0;
              }
              .select-box {
                  flex: 120px;
                  margin: 0;
              }
          }
      }
  }
</style>